import { combineReducers } from "redux";

// Layout (sidebar/topbar/sidebar-size persistence)
import Layout from "./layouts/reducer";

// Real auth state
import Login from "./auth/login/reducer";
import Profile from "./auth/profile/reducer";

const rootReducer = combineReducers({
  Layout,
  Login,
  Profile,
});

export default rootReducer;
